import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

/** Sign-up step 1: contact person details. */
@Component({
  selector: 'app-signup-step-one',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  template: `
    <div class="auth__form" [formGroup]="formGroup">
      <div class="field">
        <label for="fullName">Full name</label>
        <input
          id="fullName"
          type="text"
          class="form-control"
          formControlName="fullName"
          placeholder="Jane Doe"
          autocomplete="name"
          [class.is-invalid]="isInvalid('fullName')"
        />
        <p class="field-error" *ngIf="isInvalid('fullName')">
          {{ formGroup.get('fullName')?.errors?.['required'] ? 'Full name is required.' : 'Full name must be at least 2 characters.' }}
        </p>
      </div>

      <div class="field">
        <label for="email">Work email</label>
        <input
          id="email"
          type="email"
          class="form-control"
          formControlName="email"
          placeholder="you@company.com"
          autocomplete="email"
          [class.is-invalid]="isInvalid('email')"
        />
        <p class="field-hint" *ngIf="!isInvalid('email')">We'll send a verification code and your welcome email here.</p>
        <p class="field-error" *ngIf="isInvalid('email')">
          {{ formGroup.get('email')?.errors?.['required'] ? 'Email is required.' : 'Please enter a valid email address.' }}
        </p>
      </div>

      <div class="field">
        <label for="phone">Phone number</label>
        <input
          id="phone"
          type="tel"
          class="form-control"
          formControlName="phone"
          placeholder="+44 7700 900000"
          autocomplete="tel"
          [class.is-invalid]="isInvalid('phone')"
        />
        <p class="field-error" *ngIf="isInvalid('phone')">
          {{ formGroup.get('phone')?.errors?.['required'] ? 'Phone number is required.' : 'Enter a valid phone number, including the country code if outside your region.' }}
        </p>
      </div>

      <button type="button" class="btn-auth" (click)="onNext()" [disabled]="!isStepValid()">
        <span>Continue</span>
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
    </div>
  `
})
export class SignupStepOneComponent {
  @Input({ required: true }) formGroup!: FormGroup;
  @Output() nextStep = new EventEmitter<void>();

  private readonly controls = ['fullName', 'email', 'phone'];

  isInvalid(name: string): boolean {
    const control = this.formGroup.get(name);
    return !!(control?.invalid && control.touched);
  }

  isStepValid(): boolean {
    return this.controls.every((name) => this.formGroup.get(name)?.valid);
  }

  onNext(): void {
    this.controls.forEach((name) => this.formGroup.get(name)?.markAsTouched());
    if (this.isStepValid()) {
      this.nextStep.emit();
    }
  }
}
